import {Box, Paper} from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  tabId: string;
  horizontalPadding?: number;
  verticalPadding?: number;
  backgroundColor?: string;
  maxWidth?: string;
  minWidth?: string;
}

export default function TabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    tabId,
    horizontalPadding = 0,
    verticalPadding = 0,
    backgroundColor = 'white',
    maxWidth = '100%',
    minWidth = 'none',
    ...other
  } = props;

  return (
    <Paper
      sx={{
        background: backgroundColor,
        maxWidth: maxWidth,
        minWidth: minWidth,
        px: horizontalPadding,
        py: verticalPadding,
        margin: 0,
      }}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${tabId}.${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Box>{children}</Box>
        </Box>
      )}
    </Paper>
  );
}
